import { DropRail } from "@/components/marketplace"
import type { DropRailSection } from "@/features/feed/contract"
import { mapFeedProduct } from "@/features/feed/map-product"
import { resolveSeeAllLink } from "@/features/feed/resolve-link"
import { SectionFrame } from "@/features/feed/sections/SectionFrame"
import type { FeedSectionProps } from "@/features/feed/sections/types"

export const DropRailFeedSection = ({ section, context }: FeedSectionProps<DropRailSection>) => {
  const { eyebrow, title, accent, products, seeAll, ranked } = section.data
  if (products.length === 0) return null
  return (
    <SectionFrame section={section} context={context} ownsHeader>
      <DropRail
        eyebrow={eyebrow}
        title={title}
        accent={accent}
        products={products.map((product) => mapFeedProduct(product, context.countryCode))}
        seeAllHref={resolveSeeAllLink(seeAll, section.type, context.countryCode, context.page)}
        ranked={ranked}
        variant={section.presentation.variant === "bare" ? "bare" : "default"}
      />
    </SectionFrame>
  )
}
